const Footer = ({ footerNumber, footerText }) => (
  <div className="footer">
    <span className="footer-page-number">{footerNumber}</span>
    <span className="footer-right-text">{footerText}</span>
  </div>
);

export default Footer;
